import { Button, ButtonProps, Stack, styled, Typography } from '@mui/material';
import { LinkProps as RouterLinkProps } from 'react-router';

export const AuthWrapperStyled = styled(Stack)(({ theme }) => ({
  backgroundImage: `linear-gradient(rgba(67, 83, 255, 0.85), rgba(67, 83, 255, 0.85)), url(${require('../../assets/images/background.png')})`,
  backgroundPosition: '0 0, center',
  backgroundSize: 'auto, cover',
  backgroundRepeat: 'no-repeat',
  boxShadow: '0 32px 20px 0 rgba(0, 0, 0, 0.04)',
  aspectRatio: '72/43',
  height: 'calc(100vh - 40px)',
  backgroundColor: theme.palette.primary.main,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.spacing(6),
}));

export const SectionStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(6),
  height: '100%',
  flex: 1,
  color: theme.palette.neutral[100],
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

export const SectionContentWrapperStyled = styled(Stack)({
  height: '50%',
  justifyContent: 'flex-start',
});

export const SectionContentStyled = styled(Stack)({
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '75%',
  alignSelf: 'center',
});

export const SectionWhiteStyled = styled(SectionStyled)(({ theme }) => ({
  borderRadius: theme.spacing(2, 6, 6, 2),
  backgroundImage: `url(${require('../../assets/images/background-light.png')})`,
  backgroundPosition: '-696px -48.605px',
  backgroundSize: '200% 111.628%',
  backgroundRepeat: 'no-repeat',
  backgroundColor: theme.palette.neutral.main,
  color: theme.palette.secondary[900],
  paddingLeft: theme.spacing(12),
}));

export const SectionTitleStyled = styled(Typography)({
  fontSize: '3rem',
  lineHeight: '3.75rem',
  fontWeight: 700,
  textAlign: 'center',
});

export const SectionSubTitleStyled = styled(Typography)({
  fontSize: '1.125rem',
  lineHeight: '1.625rem',
  fontWeight: 700,
  textAlign: 'center',
  minHeight: '100px',
});

export const ButtonStyled = styled(Button)<ButtonProps & Omit<RouterLinkProps, 'variant'>>(
  ({ theme }) => ({
    boxShadow: 'none',
    fontSize: '1rem',
    lineHeight: '1.125rem',
    fontWeight: 700,
    height: '50px',
    padding: theme.spacing(0, 4),
    width: '240px',
    borderRadius: theme.spacing(4),
  }),
);

export const ButtonWhiteStyled = styled(ButtonStyled)<
  ButtonProps & Omit<RouterLinkProps, 'variant'>
>(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  color: theme.palette.primary.main,
}));

export const ButtonBlueStyled = styled(ButtonStyled)(({ theme }) => ({
  backgroundColor: theme.palette.primary[500],
  color: theme.palette.neutral[100],
}));

export const InfoTextStyled = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  lineHeight: '1.5rem',
  color: theme.palette.neutral[100],
  textAlign: 'center',
}));
